import { render } from "./ModelFrame.vue?vue&type=template&id=89d1ce10&scoped=true"
import script from "./ModelFrame.vue?vue&type=script&lang=js"
export * from "./ModelFrame.vue?vue&type=script&lang=js"

import "./ModelFrame.vue?vue&type=style&index=0&id=89d1ce10&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d1ce10"]])

export default __exports__